"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const _333ohIcon = createIcon({
  displayName: "_333ohIcon",
  viewBox: "0 0 500 500",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="m298.473 332.997c0-2.802 0-5.242 0-8.212-14.722 0-29.174.015-43.626-.003-19.157-.023-38.316.072-57.472-.166-10.302-.129-18.292-7.216-20.328-17.286-1.853-9.163 3.034-19.079 12.012-22.986 3.381-1.472 7.402-2.037 11.135-2.051 40.813-.139 81.629.009 122.443-.161 9.123-.038 15.375 4.223 21.629 10.393 25.26 24.919 50.955 49.397 76.488 74.041 3.596 3.471 6.904 7.313 10.838 10.345 6.215 4.787 8.258 10.58 8.043 18.449-.553 20.143-.186 40.312-.184 60.47v8.481c-9.523-9.161-17.688-17.688-26.564-25.398-13.682-11.885-27.795-23.277-41.836-34.744-8.523-6.962-18.785-9.397-29.422-9.31-23.133.192-46.261 1.237-69.394 1.434-28.321.242-56.652-.366-84.968.079-12.632.199-23.001-4.502-31.481-12.761-29.835-29.058-59.207-58.59-88.763-87.933-6.604-6.557-8.228-14.462-5.22-22.947 2.912-8.216 9.268-12.885 18.003-13.75 6.879-.682 12.596 2 17.604 6.694 19.688 18.456 39.46 36.825 59.202 55.224 3.777 3.521 7.468 7.144 11.396 10.486 1.268 1.08 3.166 2.005 4.778 2.009 41.318.085 82.636.04 123.953.002.472-0 .942-.21 1.734-.399z"
        fillRule="evenodd"
        fill="currentColor"
      />
      <path d="m131.259 43.322h55.921v55.921h-55.921z" fill="currentColor" />
      <path d="m209.549 43.322h55.921v55.921h-55.921z" fill="currentColor" />
      <path d="m287.838 43.322h55.922v55.921h-55.922z" fill="currentColor" />
      <path d="m131.539 121.612h55.921v55.921h-55.921z" fill="currentColor" />
      <path d="m209.828 121.612h55.922v55.921h-55.922z" fill="currentColor" />
      <path d="m288.117 121.612h55.922v55.921h-55.922z" fill="currentColor" />
      <path d="m131.679 199.901h55.921v55.921h-55.921z" fill="currentColor" />
      <path d="m209.968 199.901h55.92v55.921h-55.92z" fill="currentColor" />
      <path d="m288.258 199.901h55.92v55.921h-55.92z" fill="currentColor" />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default _333ohIcon;
